import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { EyeIcon, EyeCloseIcon, QuestionMarkIcon } from '@/icons'

import './input.scss'

const Input = ({
  value,
  onChange,
  onClick,
  labelText,
  placeholderText,
  disablePasswordToggle,
  icon,
  type,
  info,
  required,
  errorMessage,
  className
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const [error, setError] = useState()
  const handleShowPasswordClick = () => setShowPassword(!showPassword)
  const handleShowInfoClick = () => setShowInfo(!showInfo)

  useEffect(() => {
    if (required && errorMessage) {
      setError(errorMessage)
    } else {
      setError('')
    }
  }, [errorMessage])

  return (
    <div className={`obroinput-group ${className}`}>
      <div className="obroinput-label-wrapper">
        <label className="obroinput-label">{labelText}</label>
        {info && (
          <div className="info-icon" onClick={handleShowInfoClick}>
            <QuestionMarkIcon />
          </div>
        )}
      </div>
      {showInfo && <div className="info-popover">{info}</div>}
      <div className={`obroinput-wrapper ${error ? 'error-border' : ''}`}>
        {icon && <div className="obroinput-icon">{icon}</div>}
        <input
          className={`obroinput-field`}
          type={showPassword ? 'text' : type}
          placeholder={placeholderText}
          value={value}
          onChange={onChange}
          onClick={onClick}
        />
        {type === 'password' && disablePasswordToggle === false && (
          <div
            className="password-toggle-icon"
            onClick={handleShowPasswordClick}
          >
            {showPassword ? <EyeCloseIcon /> : <EyeIcon />}
          </div>
        )}
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  )
}

Input.propTypes = {
  labelText: PropTypes.string,
  placeholderText: PropTypes.string,
  icon: PropTypes.node,
  type: PropTypes.oneOf(['text', 'email', 'password', 'number']),
  info: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
}


export default Input
